import {transferify} from 'shared/utils/data-service-utils';


export function downloadBlobAsFile(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export function serializeArg(arg: any): string {
    try {
        return typeof arg === 'object' ? serializeObject(arg) : String(arg);
    } catch {
        return '[[Unserializable Object]]';
    }
}

export function serializeObject(object: Record<string, any>): string {
    return JSON.stringify(transferify(object));
}

export function generateFilename(prefix: string, extension: string): string {
    const hostname = window.location.hostname.replaceAll('.', '-');
    const timestamp = new Date().toISOString().split('.').at(0).replaceAll(':', '-');
    return `portaro-${prefix}-${hostname}-${timestamp}.${extension}`;
}